// extracted by mini-css-extract-plugin
module.exports = {"intro":"AttachFileDrawer_intro__3zlo6","close":"AttachFileDrawer_close__VtmnG","counter":"AttachFileDrawer_counter__2j13t","drawer":"AttachFileDrawer_drawer__3IiQi"};